// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import Relationship from 'modules/Settings/DataSetup/DataModel/Relationship/Izenda.Relationship';

@connect()
class RelationshipPopup extends Component {
  onClosePopup = () => {
    const { onAccept, store } = this.props;
    onAccept && onAccept();
    delete store.relationship;
    store.relationship = null;
  };

  render() {
    const { store } = this.props;
    const relationship = store.relationship;
    const dataObjectName = !!relationship ? relationship.dataObjectName : '';

    return (
      <Popup visible sizeClass="modal-relationship-size" type="border-none" onClosed={this.onClosePopup}>
        <Popup.Header title={'Relationships - ' + dataObjectName} />
        <Popup.Body>
          {!!relationship && <Relationship store={relationship} isPopup={true} onClosePopup={this.onClosePopup} />}
        </Popup.Body>
        <Popup.Footer />
      </Popup>
    );
  }
}

export default RelationshipPopup;



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.RelationshipPopup.js